// ─── Identité de l'application (Core) ─────────────────────────────
// Chaque app se déclare une fois, à la racine : son id, son nom, sa version, et
// les MODULES qu'elle compose. Le Core s'en sert pour le suivi de version (par
// app) et l'origine des faits techniques (app + module concerné).
//   <CoreProviders app={{ id:'mop-empty', nom:'MoP Empty', version:'0.1.0' }}>
// Si `modules` n'est pas fourni, on prend la composition déclarée dans APPS.
//
// `scheme` (20/08) : le schéma d'URL de l'app (`expo.scheme` de son
// `app.json`), lu par le paiement Stripe pour ramener l'utilisateur dans la
// BONNE app après le Checkout — le Core est app-agnostique, donc il ne peut
// pas le deviner.
import React, { createContext, useContext, useMemo } from 'react';
import { APP_NAME, APP_VERSION } from '../version';
import { appInfo, modulesDeApp } from '../modules';

const AppContext = createContext({ id: 'mop-empty', nom: APP_NAME, version: APP_VERSION, modules: [], scheme: '' });
export const useApp = () => useContext(AppContext);

export function AppProvider({ children, app }) {
  const value = useMemo(() => {
    const id = app?.id || 'mop-empty';
    const modules = app?.modules
      ? modulesDeApp({ modules: app.modules })
      : modulesDeApp(id);
    return {
      id,
      nom:     app?.nom     || appInfo(id).label || APP_NAME,
      version: app?.version || APP_VERSION,
      scheme:  app?.scheme  || '',
      modules,                                   // [{ id, label, emoji, mode }]
      // Module « métier » par défaut d'une remontée : le 1er hors « core ».
      moduleDefaut: (modules.find(m => m.id !== 'core') || modules[0] || { id: 'core' }).id,
    };
  }, [app?.id, app?.nom, app?.version, app?.scheme, app?.modules]);
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}
